import React, { useContext } from 'react'
import { arrayOf, number, shape, string } from 'prop-types'
import Marquee from 'react-fast-marquee'
import { ThemeContext } from '@/component/Context/ThemeContext'

import styles from './BrandLive.module.scss'
import ResponsiveImage from '@/component/Primitive/ResponsiveImage'
import Type from '@/component/Primitive/Type'
import Container from '@/component/Primitive/Container'
import classNames from 'classnames'
import Prose from '@/component/Primitive/Prose'
import Hide from '@/component/Primitive/Hide'
import ChevronTitle from '@/component/Primitive/ChevronTitle'
import { useVersionPath } from '@/component/Context/VersionPathContext'

const getImage = (brand) =>
  `/public/image/brand/live/hybrid/${brand}--live-virtual-white.png`

const BrandLive = ({ description, image }) => {
  const { theme } = useContext(ThemeContext)
  const versionPath = useVersionPath()
  const { mobile: mobileImage, desktop: desktopImage } = image
  return (
    <div className={styles.BrandLive}>
      <div className={styles.ImageWrapper}>
        <Hide at="desktop">
          <ResponsiveImage
            className={classNames(styles.Image, styles.mobileImage)}
            {...mobileImage}
          />
        </Hide>
        <Hide below="desktop">
          <ResponsiveImage
            className={classNames(styles.Image, styles.desktopImage)}
            {...desktopImage}
          />
        </Hide>
        <div className={styles.Pattern} />
        <div className={styles.ImageContent}>
          <Type themed size={['body2', 'body1']} uppercase>
            Streaming since 2021
          </Type>
          <img
            loading="lazy"
            className={styles.LiveIcon}
            src={versionPath(getImage(theme))}
            alt="Live"
          />
          <Hide below="desktop">
            <Type themed size={['body2', 'body1']} uppercase>
              London • New York • Singapore
            </Type>
          </Hide>
          <Hide at="desktop">
            <Marquee gradient={false}>
              <Type
                className={styles.LiveText}
                size={['body2', 'body1']}
                uppercase
              >
                London • New York • Singapore
              </Type>
            </Marquee>
          </Hide>
        </div>
      </div>
      <div className={styles.Live}>
        <Container className={styles.LiveContainer} gutter>
          <ChevronTitle title="Live" uppercase italic />
          <Prose className={styles.Description} dangerousHtml={description} />
        </Container>
      </div>
    </div>
  )
}

BrandLive.propTypes = {
  description: string,
  image: shape({
    mobile: shape({
      src: string,
      srcSet: arrayOf(shape({ width: number, src: string })),
      sizes: arrayOf(string)
    }),
    desktop: shape({
      src: string,
      srcSet: arrayOf(shape({ width: number, src: string })),
      sizes: arrayOf(string)
    })
  })
}

export default BrandLive
